import React from 'react'
import './Authenticate.css'
import SideNav from '../layout/SideNav'
import Card from '../core/Card'
import LoginPage from './LoginPage'
import Logo from '../core/components/Logo'
import { Col, Checkbox, Button as AButton, Switch, DatePicker, Select, Modal, Input, Icon as AIcon, Tooltip, Form, Alert, Popconfirm, Row, Progress} from 'antd';
import { Icon, BackIcon, BriefcaseIcon, CarIcon, DotIcon, ForwardIcon } from '../core/icons'
import { Field, reduxForm, submit, change } from 'redux-form'
import makeField from '../account/makeField'
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Line from '../core/Line'
import { login } from './actions'
import styled from 'styled-components'
import TextAppLink from '../home/TextAppLink'
import { push } from 'react-router-redux'
import AnalyticsHelper from '../utils/AnalyticsHelper'
import {ApiHelper } from '../utils/ApiHelper'
import CloudEvent from '../utils/CloudEvent'


import WorkStatus from '../account/business-lines/WorkStatus'
import { savePersona } from '../account/business-lines/actions'

import {
  Button,
  StepProgress,
  StepContainer,
  StepCard,
  TitleRow,
  Content
} from './steps'


const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? 'Invalid email address'
    : undefined

const AInput = makeField(Input)
// component={AInput}


const WorkStatusStep = (props) =>
<StepContainer>
  <div>
    <StepCard>
      <StepProgress step={1}/>
    </StepCard>

    <StepCard>
      <TitleRow>
        <h3>What is your work status?</h3>
        <Button primary loading={props.submitting} onClick={props.handleSubmit}>Continue</Button>
      </TitleRow>
      <Content>
        <WorkStatus {...props} form="WorkStatus"/>
        {props.isEmployee &&
          <div>
            <h3 style={{margin:'50px 0', fontSize:30}}>Who is your employer?</h3>
            <Field
              name="companyName"
              placeholder="Company name"
              type="text"
              component={AInput}
              label="Company name"
            />
            <Field
              name="managerEmail"
              placeholder="Manager email"
              validate={email}
              type="email"
              label="Manager email"
              component={AInput}
            />
          </div>
        }
      </Content>
    </StepCard>
  </div>
</StepContainer>

const mapStateToProps = ({account: { businessLines: {persona} }}) =>
  ({isEmployee: persona.includes('Employee')})

const WorkStatusForm = reduxForm({
  form: 'WorkStatus',
  onSubmit: (data, dispatch, ownProps)=> {
    dispatch(savePersona(data))
    .then(()=>{
      if (data.companyName) {
        dispatch({type:'CUSTOM_LINE_CHANGE', value:data.companyName})
        dispatch({type:"SUBMIT_CUSTOM_LINE"})
      }

      if (data.managerEmail) {
        // same as data exports email invite action:
        ApiHelper.createInvite({email:data.managerEmail, type:'InviteManager'})
      }

      AnalyticsHelper.trackEvent(CloudEvent.OnboardingStep1, {
        'Manager Email': !!data.managerEmail, 'Company Name': !!data.companyName
      })

      dispatch(push('step-two'))
    })
  },
})(
  connect(mapStateToProps)(WorkStatusStep)
)

export default WorkStatusForm



// WEBPACK FOOTER //
// ./src/user/StepOne.js